import React from "react";
import "../App.css";
import MediaTextSection from "./MediaTextSection";
import AboutIllustration from "./AboutIllustration";

export default function About() {
  return (
    <MediaTextSection
      title="Mais do que Contabilidade, uma parceria para o seu negócio"
      paragraphs={[
        "Na Eniato, transformamos a contabilidade em uma ferramenta estratégica. Nosso compromisso é com a excelência técnica, atendimento consultivo e a segurança das informações, garantindo que sua empresa esteja sempre à frente e preparada para o crescimento sustentável.",
      ]}
      button={{ label: "Conheça nossa história", to: "/sobre" }}
      media={<AboutIllustration />}
    />
  );
}
